export default __webpack_public_path__ + "static/media/atm_services.949411c8.jpg";